import { Controller } from "@hotwired/stimulus"

// MS54 #3040 — "retry-countdown" Stimulus controller.
//
// CSP-safe replacement for the nonce-less inline IIFE that drove the 503
// auto-retry countdown on app/views/errors/show.html.erb. The enforcing nonce
// CSP (script-src :self + nonce, no unsafe_inline — #1222) silently blocks
// nonce-less inline scripts, so the 503 page never auto-retried. connect()
// starts a 1s interval that decrements the counter, shrinks the progress bar,
// and reloads the page at zero — mirroring history_back / resume_reveal.
export default class extends Controller {
  static targets = ["timer", "progress"]
  static values = { seconds: { type: Number, default: 30 } }

  connect() {
    this.total = this.secondsValue
    this.remaining = this.total
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    this.stop()
  }

  tick() {
    this.remaining--

    if (this.hasTimerTarget) this.timerTarget.textContent = this.remaining
    if (this.hasProgressTarget) {
      this.progressTarget.style.width = `${(this.remaining / this.total) * 100}%`
    }

    if (this.remaining <= 0) {
      this.stop()
      window.location.reload()
    }
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}
